// extracted by mini-css-extract-plugin
module.exports = {"comparisonSearch":"styles_comparisonSearch__zJCqg"};